<template>
    <v-container>
        <v-card class="pl-10 pr-10">
            <v-card-title class="pb-0">
                <b>รายงานวัสดุสิ้นเปลือง เข้า/ออก</b>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <v-spacer></v-spacer>
                <UserBranchDropdown :pageCode="pageCode" @onUserBranchChange='setCurrentBranch'
                 @onUserBranchNameChange='setCurrentBranchName'></UserBranchDropdown>
            </v-card-title>
            <v-divider></v-divider>

            <template>
                <v-container>
                    <v-card outlined>
                        <v-card-subtitle class="pb-0">
                        <v-row>
                            <v-col cols="12" >
                                <v-card  class="pb-0">
                                    <v-card-subtitle  class="pb-0">ประเภท</v-card-subtitle>
                                    <v-divider  class="mx-4"></v-divider>
                                    <v-card-text  class="pb-0">
                                         <v-row >
                                         <v-col  v-bind:key="t.value" v-for="t in listTypeConsummer">
                                             <v-checkbox v-model="select"
                                    :label="t.display" :value="t.value"
                                >
                                </v-checkbox>
                                         </v-col>
                                    </v-row>
                                    </v-card-text>
                                   
                                </v-card>
                               
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col><DatePicker label="ตั้งแต่ วันที่" @dateFormatted="setDateFrom" ></DatePicker></v-col>
                            <v-col><DatePicker label="ถึง วันที่" @dateFormatted="setDateTo" ></DatePicker></v-col>
                            <v-spacer></v-spacer>
                            <v-col class="text-right">
                                <v-row>
                                    <v-btn  class="ma-2" color="primary" small @click="search"><v-icon>search</v-icon> ค้นหา</v-btn>
                                     <v-btn :disabled="items.length == 0"  class="ma-2" color="primary" small @click="createReport"><v-icon >mdi-floppy</v-icon> สร้างรายงาน</v-btn>
                                </v-row>
                            </v-col>
                            
                        </v-row>  
                        <v-row>
                           <v-col><b>Stock in : {{this.sumStockInDisplay}} <span style="padding-left:20px ;">Stock out : {{this.sumStockOutDisplay}} </span></b>  </v-col>
                        </v-row>           
                        </v-card-subtitle>
                    </v-card>
                </v-container>
            </template>

         <template  width="1000px">
            <v-data-table 
                :items="items"
                class="pt-5"
                >
                <template v-slot:header>
                    <thead>
                        <tr>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>No.</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>รหัสสินค้า</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>รายการวัสดุสิ้นเปลือง</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>ประเภท</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>ราคา/หน่วยใหญ่</span></h3>
                            </th>
                            <th rowspan="3"  class="border">
                                <h3 class="text-center" ><span>หน่วยใหญ่</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>ราคา/หน่วยย่อย</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>หน่วยย่อย</span></h3>
                            </th>
                            <th rowspan="3" class="border">
                                <h3 class="text-center" ><span>ปริมาณหน่วยรับเข้า</span></h3>
                            </th>
                            <th colspan="3" class="border">
                                <h3 class="text-center" ><span>Stock In</span></h3>
                            </th>
                            <th colspan="3" class="border">
                                <h3 class="text-center" ><span>Stock Out</span></h3>
                            </th>
                            <th colspan="3" class="border">
                                <h3 class="text-center" ><span>คงเหลือ</span></h3>
                            </th>
                        </tr>
                        <tr>
                            <th colspan="2" class="border">
                                <h3 class="text-center" ><span>จำนวน</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ยอดรวม</span></h3>
                            </th>
                            <th colspan="2" class="border">
                                <h3 class="text-center" ><span>จำนวน</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ยอดรวม</span></h3>
                            </th>
                            <th colspan="2" class="border">
                                <h3 class="text-center" ><span>จำนวน</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ยอดรวม</span></h3>
                            </th>
                        </tr>
                        <tr>
                            <th class="border">
                                <h3 class="text-center" ><span>ใหญ่</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ย่อย</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span></span></h3>
                            </th>

                            <th class="border">
                                <h3 class="text-center" ><span>ใหญ่</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ย่อย</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span></span></h3>
                            </th>

                            <th class="border">
                                <h3 class="text-center" ><span>ใหญ่</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span>ย่อย</span></h3>
                            </th>
                            <th class="border">
                                <h3 class="text-center" ><span></span></h3>
                            </th>
                        </tr>
                    </thead>
                </template>

                <template v-slot:body="{ items }">
                    <tbody name="list" >
                         <tr v-if="items.length == 0" class="text-center">
                            <td colspan="14"> ไม่พบข้อมูล
                            </td>
                        </tr>
                         <tr  v-else v-for="item in items" :key="item.no" class="item-row text-center">
                             <td >{{item.rowNumber}}</td>
                             <td>{{item.consumableCode}}</td>
                             <td class="text-left">{{item.consumableName}}</td>
                             <td>{{item.consumableType}}</td>
                             <td>{{item.priceDisplay}}</td>
                             <td>{{item.unitOfPrice}}</td>
                             <td>{{item.unitPriceDisplay}}</td>
                             <td>{{item.unitOfSize}}</td>
                             <td>{{item.size}}</td>
                             <td>{{item.stockInQtyBigDisplay}}</td>
                             <td>{{item.stockInQtySmallDisplay}}</td>
                             <td>{{item.stockInPriceDisplay}}</td>
                             <td>{{item.stockOutQtyBigDisplay}}</td>
                             <td>{{item.stockOutQtySmallDisplay}}</td>
                             <td>{{item.stockOutPriceDisplay}}</td>
                             <td>{{item.remainQtyBigDisplay}}</td>
                             <td>{{item.remainQtySmallDisplay}}</td>
                             <td>{{item.remainPriceDisplay}}</td>
                         </tr>
                    </tbody>
                </template>
            </v-data-table>
         </template>
        </v-card>       
    </v-container>
</template>

<style scoped>
    td {
        white-space: nowrap;
    }

    th {
        white-space: nowrap;
    }
    .border {
        border: black;
        border-style: solid;
        border-width: 1px;
    }

    .border-body {
        border: black;
        border-style: solid;
        border-width: 0px 0px 1px 1px;
    }
    .border-close {
        border: black;
        border-style: solid;
        border-width: 0px 1px 1px 1px;
    }
</style>
<script>

 import UserBranchDropdown from '@/components/Shared/UserBranchDropdown'
 import DatePicker from '@/components/Shared/DatePicker'
 import {listTrnConsumable,exportTrnConsumable} from '@/api/reports/report-api.js'
 import numeral from 'numeral'

export default {
    name: 'CarService',
    components: {
        UserBranchDropdown,
        DatePicker
    },
   props:["pageCode"],
    data: () => ({
        select: ['S', 'A'],
        listTypeConsummer: [
            { display: 'วัสดุสิ้นเปลืองในงานซ่อม', value: 'S' },
            { display: 'ส่วนกลาง', value: 'A' },
            { display: 'สี', value: 'C' },
            { display: 'สำนักงาน', value: 'O' },
            { display: 'ยา', value: 'D' },
        ],
        items: [],
        sumStockIn : 0.00,
        sumStockOut : 0.00,
        sumStockInDisplay : '0.00',
        sumStockOutDisplay : '0.00',
    }),
    methods: {
            setDateFrom(val) {
                  this.dateFrom = val;
            },
            setDateTo(val) {
                  this.dateTo = val;
            },
            setCurrentBranch(branchCode) {
                this.branchCode = branchCode;
            },
            setCurrentBranchName(branchName) {
                this.branchName = branchName;
            },
            search(){
              this.sumStockIn = 0.00;
              this.sumStockOut = 0.00;

              this.$loading(true);
                listTrnConsumable(this.branchCode,this.select,this.dateFrom,this.dateTo).then(response => {
                this.items = response;
                 if (this.items) {
                this.items.forEach((e) => {
                    e.unitPriceDisplay = numeral(e.unitPrice).format('0,0.00');
                    e.priceDisplay = numeral(e.price).format('0,0.00');
                    e.stockOutPriceDisplay = numeral(e.stockOutPrice).format('0,0.00');

                    e.stockInQtyBigDisplay = numeral(e.stockInQtyBigSize).format('0,0.00');
                    e.stockInQtySmallDisplay = numeral(e.stockInQtySmallSize).format('0,0.00');
                    e.stockInPriceDisplay = numeral(e.stockInPrice).format('0,0.00');

                    e.stockOutQtyBigDisplay = numeral(e.stockOutQtyBigSize).format('0,0.00');
                    e.stockOutQtySmallDisplay = numeral(e.stockOutQtySmallSize).format('0,0.00');
                    e.stockOutPriceDisplay = numeral(e.stockOutPrice).format('0,0.00');

                    e.remainQtyBigDisplay = numeral(e.remainQtyBigSize).format('0,0.00');
                    e.remainQtySmallDisplay = numeral(e.remainQtySmallSize).format('0,0.00');
                    e.remainPriceDisplay = numeral(e.remainPrice).format('0,0.00');

                    this.sumStockIn += e.stockInPrice;
                    this.sumStockOut += e.stockOutPrice;

                });

                this.sumStockInDisplay = numeral(this.sumStockIn).format('0,0.00');
                this.sumStockOutDisplay = numeral(this.sumStockOut).format('0,0.00');
            }
                this.$loading(false);
                }).catch(()=> {
                    this.$loading(false);
                });
            },
            createReport(){
                this.$loading(true);
                exportTrnConsumable(this.branchCode,this.branchName,this.select,this.dateFrom,this.dateTo);
                this.$loading(false);
            },
    }
}
</script>